import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {z as r} from 'zod';

import {fetchAndDeserialize, getUrlParameters} from '../../util/api-adapter';

import {reviewAdditionalDataSchema} from './reviews-type';

const reviewInfoDataSchema = r.object({
    id: r.number(),
    notesCount: r.number(),
    canManageReview: r.boolean(),
    additionalData: reviewAdditionalDataSchema.nullable().optional(),
});

const fetchReviewsInfoSchema = r.object({
    results: r.array(reviewInfoDataSchema),
});

export type FetchReviewsInfoDataType = r.infer<typeof fetchReviewsInfoSchema>;
export type ReviewInfoDataType = r.infer<typeof reviewInfoDataSchema>;

function getReviewsInfoUrl(reviewIds: Array<number>): string {
    return `/v4/reviews/info/${getUrlParameters({review_ids: reviewIds})}`;
}

function getReviewsInfoQueryKey(reviewIds: Array<number>): [string] {
    return [getReviewsInfoUrl(reviewIds)];
}

async function fetchReviewsInfo(reviewIds: Array<number>): Promise<FetchReviewsInfoDataType> {
    return fetchAndDeserialize<FetchReviewsInfoDataType>(getReviewsInfoUrl(reviewIds), fetchReviewsInfoSchema);
}

export function useReviewsInfo(reviewIds: Array<number>): UseQueryResult<FetchReviewsInfoDataType> {
    return useQuery(getReviewsInfoQueryKey(reviewIds), () => fetchReviewsInfo(reviewIds), {
        enabled: reviewIds.length > 0,
        refetchOnWindowFocus: false,
    });
}
